// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__CBZBq","containerForm":"styles_containerForm__lwHfi","register-text":"styles_register-text__BTJiy","background":"styles_background__jIFFa"};